module.exports = __webpack_public_path__ + "static/21-metallica-april2000-e857f2e0953a3a4cc11a5fedeae66606.jpg";